import { render } from "./DaftarRTH.vue?vue&type=template&id=56289628"
import script from "./DaftarRTH.vue?vue&type=script&lang=js"
export * from "./DaftarRTH.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__